/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { Backdrop, Button, CircularProgress, Grid, Paper } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CHANGE_TITLE } from "../../../store/theming";
import { Delete as DeleteIcon, ChevronLeft } from "@mui/icons-material";
import ButtonEdit from "../../../components/base/ButtonEdit";
import { useState } from "react";
import { getApi } from "../../../store/apis";
import { useNavigate, useParams } from "react-router-dom";
import day from "dayjs";
import { DialogDelete } from "../../../components/base/dialogDelete";
import VcrListUser from "./vcrListUser";

const VcrDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.myTheme);
  const [loading, setLoading] = useState(true);
  const [dataSet, setData] = useState(null);
  const navigate = useNavigate();
  const fetchData = () => {
    setLoading(true);
    let data = {
      path: `admin/voucher/detail?id=${id}`,
    };
    dispatch(getApi(data))
      .then((data) => {
        console.log(data);
        setLoading(false);
        setData(data);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const [dialog, setDialog] = useState(false);
  const [pocket, setPocket] = useState(null);
  const deleteData = () => {
    setPocket({
      path: "admin/voucher/delete",
      body: {
        id: id,
      },
    });
    setDialog(true);
  };
  useEffect(() => {
    dispatch(CHANGE_TITLE("Detail Voucher"));
    fetchData();
  }, []);
  const currencyFormater = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const colorStatus = (value) => {
    let data = {};
    switch (value) {
      case "close":
        data = {
          title: "Not Publish",
          titleColor: theme.white,
          color: theme.act_lbl_red,
        };
        break;
      default:
        data = {
          title: "Publish",
          titleColor: theme.white,
          color: theme.act_lbl_cyan,
        };
        break;
    }

    return data;
  };

  return (
    <div>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Button variant="contained" style={{ minWidth: "0" }} className="capitalize rounded-lg  mb-3" onClick={() => navigate("/voucher-activity")}>
        <ChevronLeft /> Kembali
      </Button>
      {!loading ? (
        <Paper className="py-5 px-2 rounded-lg mb-5 relative">
          <div className="absolute rounded-bottom-lg py-1 px-3" style={{ top: 0, right: 20, background: colorStatus(dataSet.status).color }}>
            <small className="font-weight-500" style={{ color: colorStatus(dataSet.status).titleColor }}>
              {colorStatus(dataSet.status).title}
            </small>
          </div>
          <div className="px-3">
            <div className="d-flex justify-space-between mb-2">
              <div className="rounded-lg py-3 px-4 d-flex justify-space-between flex-wrap gap-x-5 gap-y-2" style={{ background: theme.tertiary }}>
                <div>
                  <span className="font-weight-500 small_txt" style={{ color: theme.act_lbl_blue }}>
                    Voucher {dataSet.type}
                  </span>
                  <div className="leading-4">
                    <h5>{dataSet.nama}</h5>
                    {dataSet.data_grup ? <span className="small_txt">{dataSet.data_grup?.nama ?? ""}</span> : <></>}
                  </div>
                </div>
                <div className="d-flex align-center gap-2">
                  <div className="rounded-lg py-2 px-4 d-flex flex-column align-center justify-center" style={{ border: `1.5px solid ${theme.act_cyan}`, background: theme.white }}>
                    <small className="font-weight-500" style={{ color: theme.act_lbl_cyan }}>
                      Kuota
                    </small>
                    <small className="font-weight-bold">{dataSet.kuota ?? "0"}</small>
                  </div>
                  <div className="rounded-lg py-2 px-4 d-flex flex-column align-center justify-center" style={{ border: `1.5px solid ${theme.act_yellow}`, background: theme.white }}>
                    <small className="font-weight-500" style={{ color: theme.act_lbl_yellow }}>
                      Claimed
                    </small>
                    <small className="font-weight-bold">{dataSet.data_voucher_pelanggan_count ?? "0"}</small>
                  </div>
                  <div className="rounded-lg py-2 px-4 d-flex flex-column align-center justify-center" style={{ border: `1.5px solid ${theme.act_green}`, background: theme.white }}>
                    <small className="font-weight-500" style={{ color: theme.act_lbl_green }}>
                      Redeem
                    </small>
                    <small className="font-weight-bold">{dataSet.jumlah_reedem ?? "0"}</small>
                  </div>
                </div>
              </div>
              <div className="d-flex align-center gap-2">
                <ButtonEdit onClick={() => navigate(`/voucher/post/${id}`)} />
                <Button
                  variant="contained"
                  className="rounded-lg capitalize"
                  disableElevation
                  size="small"
                  style={{
                    background: theme.act_red,
                    height: "max-content",
                  }}
                  onClick={deleteData}>
                  <DeleteIcon className="mr-1" style={{ color: theme.act_lbl_red }} />
                  <p className="font-weight-bold" style={{ color: theme.act_lbl_red }}>
                    Delete
                  </p>
                </Button>
              </div>
            </div>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <div className="px-3">
                <ul className="mx-3">
                  <li style={{ color: theme.primary }}>
                    <p style={{ fontWeight: "500" }}>Informasi Voucher</p>
                    <div className="mt-3" style={{ color: "black" }}>
                      <div className="mt-2">
                        <p className="small_txt font-weight-bold" style={{ color: theme.primary }}>
                          Kode Voucher
                        </p>
                        <p className="small_txt">
                          <span className="font-weight-500">{dataSet.kode}</span>
                        </p>
                      </div>
                      <div className="mt-2">
                        <p className="small_txt font-weight-bold" style={{ color: theme.primary }}>
                          Nama Voucher
                        </p>
                        <p className="small_txt">{dataSet.nama}</p>
                      </div>
                      <div className="mt-2">
                        <p className="small_txt font-weight-bold" style={{ color: theme.primary }}>
                          Deskripsi Voucher
                        </p>
                        <p className="small_txt">{dataSet.deskripsi}</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </Grid>
            <Grid item xs={8}>
              <div className="px-3">
                <ul className="mx-3">
                  <li style={{ color: theme.primary }}>
                    <p style={{ fontWeight: "500" }}>Detail Voucher </p>
                    <div className="mt-3" style={{ color: "black" }}>
                      <div className="d-flex flex-wrap gap-5">
                        <div>
                          <p className="small_txt font-weight-bold" style={{ color: theme.primary }}>
                            Expired Redeem
                          </p>
                          <p className="small_txt">{dataSet.expire_date ? day(dataSet.expire_date).locale("id").format("DD MMMM YYYY") : ""}</p>
                        </div>
                        <div>
                          <p className="small_txt font-weight-bold" style={{ color: theme.primary }}>
                            Expired Service
                          </p>
                          <p className="small_txt">{dataSet.exp_layanan ? day(dataSet.exp_layanan).locale("id").format("DD MMMM YYYY") : ""}</p>
                        </div>
                        <div>
                          <p className="small_txt font-weight-bold" style={{ color: theme.primary }}>
                            Harga Voucher
                          </p>
                          <p className="small_txt">
                            {dataSet.nominal == 0 ? (
                              <span className="font-weight-bold" style={{ color: theme.primary }}>
                                Gratis
                              </span>
                            ) : (
                              `Rp${currencyFormater(dataSet.nominal)}`
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex flex-wrap gap-5">
                        {dataSet.layanan_decode?.psikotes?.length > 0 && (
                          <div className="mt-2">
                            <p className="small_txt font-weight-bold" style={{ color: theme.primary }}>
                              Psikotes
                            </p>
                            <ul>
                              {dataSet?.layanan_decode?.psikotes?.map((item, index) => {
                                return (
                                  <li key={index}>
                                    <small>{item.name}</small>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        )}
                        {dataSet.layanan_decode?.konsultasi?.length > 0 && (
                          <div className="mt-2">
                            <p className="small_txt font-weight-bold" style={{ color: theme.primary }}>
                              Konsultasi
                            </p>
                            <ul>
                              {dataSet?.layanan_decode?.konsultasi?.map((item, index) => {
                                return (
                                  <li key={index}>
                                    <small>{item.name}</small>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </Grid>
          </Grid>
        </Paper>
      ) : (
        <></>
      )}
      <VcrListUser id={id} />
      <div className="pa-2">
        <DialogDelete d_del={dialog} close={() => setDialog(false)} pocket={pocket} refetch={() => navigate("/voucher-activity")} />
      </div>
    </div>
  );
};

export default VcrDetail;
